import {
  GetAvailableSitesRequest,
  GetAvailableSitesResponse
} from '@atlassiansox/asc-stargate';
import { AsyncResult, useAsync } from './use-async';
import { useStargateClient } from './use-stargate-client';

export type { GetAvailableSitesRequest, GetAvailableSitesResponse };

export function useAvailableSites({
  orderId,
  transactionAccount
}: GetAvailableSitesRequest): AsyncResult<GetAvailableSitesResponse> {
  const stargateClient = useStargateClient();

  return useAsync(
    () =>
      stargateClient.getAvailableSites({
        orderId,
        transactionAccount,
        webPlatform: 'magnolia'
      }),
    []
  );
}
